import type { Slide } from "~/graphql/types";

export function getSlideIndex(timestamp: number, slides?: Maybe<Slide[]>) {
  return (
    slides
      ?.filter((s) => s.timestamp <= (timestamp || 0))
      .map((_s, index) => index)
      .reduce((a, b) => (a < b ? b : a)) || 0
  );
}
